import { BaseRepository } from "@/repository/base";
import { IItem } from "@/schemas/IItem";

const itemRepository = new BaseRepository<IItem>("items");

export default itemRepository;
